import {useEffect, useRef, useState} from "react";
import {VariantService} from "./Service";
import 'react-quill/dist/quill.snow.css';
import Select from "react-select";
import {toast} from "react-hot-toast";
import {useParams} from "react-router-dom";
import { SettingService } from "../setting/Service";


const AddVariant = () => {
    const {product} = useParams();
    const service = new VariantService();
    const settingService = new SettingService();
    const [colorOptions, setColorOptions] = useState<{ label: string, value: string }[]>([]);
    const [discount, setDiscount] = useState(0);
    const [purchasePrice, setPurchasePrice] = useState(0);
    const [salePrice, setSalePrice] = useState(0);
    const [size, setSize] = useState(0);
    const [unit, setUnit] = useState<{ label: string, value: string } | null>(null);
    const [type, setType] = useState<{ label: string, value: string } | null>(null);
    const unitOptions = [
        {
            label: 'mm', value: 'MM'
        },
        {
            label: 'inch', value: 'Inch'
        }
    ];

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        toast.loading('Adding product variant...');
        const data = {
            purchasePrice: purchasePrice,
            salePrice: salePrice ? salePrice : 0,
            size: size,
            type: type?.value,
            unit: unit?.value,
            product: parseInt(product!),
            discount: discount,
        }
        const res = await service.add(data);
        if (res) {
            toast.success('Variant added successfully');
            setPurchasePrice(0);
            setSalePrice(0);
            setSize(0);
            setDiscount(0);
            setType(null);
            setUnit(null);
        }
    }

    const fetchColors = async () => {
        const res = await settingService.allColors();
        if (res) {
            const options = res.map((color: any) => ({
                label: color.name,
                value: color.name
            }));
            setColorOptions(options);
        }
    }

    useEffect(() => {
        fetchColors();
    }, []);


    return (
        <>
            <div className="card mb-0">
                <div className="card-body">
                    <div className="page-header">
                        <div className="content-page-header">
                            <h5>Add Product Variant</h5>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit} className="row">
                        <div className='row col-12'>
                            <div className="col-lg-6 col-12">
                                <div className="input-block mb-3">
                                    <label>Size <span className="text-danger">(required)</span></label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter size"
                                        value={size}
                                        onChange={(e) => setSize(parseFloat(e.target.value))}
                                        required={true}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-12">
                                <div className="input-block mb-3">
                                    <label>Discount %</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter discount percentage"
                                        value={discount}
                                        onChange={(e) => setDiscount(parseFloat(e.target.value))}
                                        required={false}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-12">
                                <div className="input-block mb-3">
                                    <label>Purchase Price <span className="text-danger">(required)</span></label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter product purchase price"
                                        value={purchasePrice}
                                        onChange={(e) => setPurchasePrice(parseFloat(e.target.value))}
                                        required={true}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-12">
                                <div className="input-block mb-3">
                                    <label>Sale Price </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter product sale price"
                                        value={salePrice}
                                        onChange={(e) => setSalePrice(parseFloat(e.target.value))}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 mb-3">
                            <label htmlFor="type" className="form-label">Type</label>
                            <Select
                                name="type"
                                options={colorOptions}
                                value={type}
                                onChange={setType}/>
                        </div>
                        <div className="col-lg-6 col-12 mb-3">
                            <label htmlFor="unit" className="form-label">Unit <span
                                className="text-danger">(required)</span></label>
                            <Select
                                name="unit"
                                options={unitOptions}
                                value={unit}
                                onChange={setUnit}/>
                        </div>


                        <div className="col-lg-12">
                            <div className="btn-path text-end">
                                <a
                                    href="javascript:void(0);"
                                    className="btn btn-cancel bg-primary-light me-3"
                                    onClick={() => {
                                        window.history.back();
                                    }}
                                >
                                    Back
                                </a>
                                <button type="submit" className="btn btn-primary">
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default AddVariant;